import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';

export function registerResetPasswordFormResourceBundleDe(i18next: i18n): void {
  i18next.addResourceBundle(
    'de',
    'record-it-components',
    {
      form: {
        ResetPasswordForm: {
          cancel: 'Abbrechen',
          noPasswordEnteredText: 'Es wurde kein Passwort eingeben.',
          passwordLabel: 'Neues Passwort',
          resettingPasswordFailedText:
            'Es ist ein Fehler beim Zurücksetzen aufgetreten.',
          resetPassword: 'Passwort zurücksetzen',
          successNotification: {
            title: 'Passwort wurde erfolgreich zurückgesetzt',
            message: 'Sie können sich jetzt mit Ihrem neuen Passwort einloggen.'
          },
          title: 'Passwort zurücksetzen'
        }
      }
    } as Partial<CustomTypeOptions['resources']['record-it-components']>,
    true
  );
}
